import { FontAwesomeIcons } from "../../core/Types";
import Icon from "./Icon";

interface IProps {
    id?: string
    icon: FontAwesomeIcons
    type?: "solid" | "regular" | "light" | "thin" | "brands"
    size?: number
    gap?: number
    className?: string
    title?: string
    working?: boolean
    href?: string
    target?: React.HTMLAttributeAnchorTarget
    doutone?: boolean
    onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}

export default function IconButton(props: IProps) {


    return (
        <>
            {
                props.href ?
                    <a id={props.id} href={props.href} target={props.target} title={props.title}
                        className={"btn btn-sm btn-icon icon-button " + props.className}
                        style={{
                            borderRadius: "50%",
                            width: (props.size ?? 26) + (props.gap ?? 20),
                            height: (props.size ?? 26) + (props.gap ?? 20),
                        }}>
                        <Icon doutone={props.doutone} icon={props.icon} type={props.type ?? "thin"} size={props.size ?? 26} />
                    </a>
                    :
                    <button id={props.id} type="button" title={props.title} disabled={props.working}
                        className={"btn btn-sm btn-icon icon-button " + props.className}
                        style={{
                            borderRadius: "50%",
                            width: (props.size ?? 26) + (props.gap ?? 20),
                            height: (props.size ?? 26) + (props.gap ?? 20),
                        }}
                        onClick={e => {
                            e.preventDefault();
                            if (props.onClick) props.onClick(e)
                        }}>
                        {
                            props.working ?
                                <Icon doutone={props.doutone} icon={"spinner-third"} spin type={props.type ?? "thin"} size={props.size ?? 26} />
                                :
                                <Icon doutone={props.doutone} icon={props.icon} type={props.type ?? "thin"} size={props.size ?? 26} />
                        }

                    </button>
            }
        </>

    )
}